import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import '../pages/css/CustomSoftwareDevelopment.css';
import '../pages/css/Home.css';
import banner from '../images/mvp-banner.jpg';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import OurPartner from '../pages/components/OurPartner';
import Industries from '../pages/components/Industries';
import TechStack from '../pages/components/TechStack';
import CaseStudy from '../pages/components/CaseStudy';
import ComparisonTable from '../pages/components/ComparisonTable';
import WorkSteps from '../pages/components/WorkSteps';
import ClientReviews from '../pages/components/ClientReviews';
import WorldwideCountries from '../pages/components/WorldwideCountries';
import Faq from '../pages/components/Faq';

function MVP() {
    const scrollRef = useRef(null);

    const scroll = (direction) => {
        const scrollAmount = 300; // pixels to scroll
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth',
            });
        }
    };
    const boxTitles = [
        "Landing Page MVP",
        "No-Code MVP",
        "Wizard of Oz MVP",
        "Concierge MVP",
        "Single-Feature MVP",
        "Mobile/Web App MVP",
        "AI-Powered MVP",
        "Prototype MVP",
        "Email Campaign MVP",
        "Explainer Video MVP",
        "Pre-Order MVP",
        "Crowdfunding MVP"

    ];
    return (
        <>
            <section
                id="home"
                style={{
                    backgroundImage: `url(${banner})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    position: 'relative', // Important for overlay
                    zIndex: 1,
                }}
            >
                {/* Overlay */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.8)', // semi-transparent black
                        zIndex: 2,
                    }}
                ></div>

                <section className="container-fluid px-3 px-md-5 pt-2 pb-4 pb-md-5" style={{ position: 'relative', zIndex: 3 }}>
                    <div className="row g-0">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center align-items-md-start text-center text-md-start p-3 p-md-4">
                            <motion.div
                                initial={{ opacity: 0, y: 50 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: false, amount: 0.1 }}
                                transition={{ duration: 0.8, ease: 'easeOut' }}
                                className="w-100"
                            >
                                <h1 className="display-5 display-md-4 fw-bold title-text text-white">Minimum Viable Product <span className="highlight-orange">(MVP)</span>
                                </h1>
                                <p className="mb-4 fw-semibold fs-4 text-white" style={{ maxWidth: '800px' }}>
                                    Turning visionary ideas into actionable prototypes with lean, scalable MVPs for faster market validation and growth.
                                </p>
                                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-md-start align-items-center">
                                    <button className="btn custom-orange-btn py-3 px-5 fw-bold d-flex align-items-center text-center" onClick={() => window.location.href = '/case-studies'}>
                                        Case Study <FaArrowRight className="ms-2" />
                                    </button>
                                    <button className="btn custom-orange-btn py-3 px-5 fw-bold d-flex align-items-center text-center" onClick={() => window.location.href = '/contact-us'}>
                                        Contact Us <FaArrowRight className="ms-2" />
                                    </button>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </section>
            </section>
            <OurPartner />
            <motion.section id="testimonials" className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">

                    <div
                        className="px-3 fw-bold responsive-heading"
                    >
                        Types of  <span className="highlight-orange">MVP Development</span> Services
                    </div>

                </div>
            </motion.section>
            <motion.div className="container my-5"
                initial={{ y: 30, opacity: 0 }}
                whileInView={{ y: 0, opacity: 1 }}
                viewport={{ once: false, amount: 0.6 }}
                transition={{ duration: 0.8, ease: "easeOut" }}>

                <div className="row py-3">
                    {boxTitles.map((title, index) => (
                        <div key={index} className="col-6 col-md-4 col-lg-2 mb-4 d-flex align-items-center justify-content-center">
                            <div className="scroll-box text-center px-3 py-2 w-100">
                                <h6>{String(index + 1).padStart(2, '0')}<br />{title}</h6>
                            </div>
                        </div>
                    ))}
                </div>

            </motion.div>
            <Industries />
            <TechStack />
            <CaseStudy />
            <ComparisonTable />
            <WorkSteps />
            <ClientReviews />
            <WorldwideCountries />
            <Faq />

        </>
    );
};


export default MVP